/** @typedef {import("../../types").StateVisualizacao} StateVisualizacao */

/**
 * Estado inicial do módulo Vuex "relatoOcorrencia/visualizacao" (namespaced).
 * Armazena a ocorrência selecionada no grid para visualização de detalhes.
 * @type {StateVisualizacao}
 */
export default {
  ocorrenciaSelecionada: null
};